import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../../../types/types';
import { ERestDriveDocType } from '../../../../../../../../types/rest/IRestDriveDoc';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { IDriveDoc } from '../../../../../../../../store/model/card/types/IDriveDoc';
import { setCommentAttachmentAddedSessionStorage } from '../../../helpers/setCommentAttachmentAddedSessionStorage';
import { showDocDriveWindow } from '../../../../../../aside_panel/cardDetails/effects/showDocDriveWindow';
import { getIsChatViewActive } from '../../../../../../../../store/router/selectors/getIsChatViewActive';
import { SegmentCardSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onAddAttachments = (
    cardId: TCardId,
    attachments: IDriveDoc[] = [],
    setAttachments: (docs: IDriveDoc[]) => void,
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.COMMENT_ATTACHMENT_ADD_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: getIsChatViewActive(getState()) ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
        }));

        dispatch(showDocDriveWindow(
            cardId,
            attachments,
            ERestDriveDocType.COMMENT,
            (docs) => {
                setCommentAttachmentAddedSessionStorage();
                setAttachments(docs);
            }
        ));
    };
};
